import {
  API_ENDPOINTS,
  GenericObjectInterface,
  headersList,
  makeApiRequest,
} from "@/src/utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchVendorCategories = createAsyncThunk<GenericObjectInterface>(
  "ungated/vendorcategories",
  async (_, { rejectWithValue, getState }) => {
    const state: any = getState();

    console.log('[fetchVendorCategories] Starting API call to:', API_ENDPOINTS.VENDOR_CATEGORIES);

    try {
      const headerList = {
        ...headersList,
        // Authorization: `Token ${userStateReducer?.userToken}`,
      };
      const response = await makeApiRequest<GenericObjectInterface>(
        "get",
        API_ENDPOINTS.VENDOR_CATEGORIES,
        null,
        headerList
      );

      console.log('[fetchVendorCategories] API call successful:', {
        status: response?.status,
        dataLength: response?.data?.length,
        hasData: !!response?.data
      });

      return response;
    } catch (error: any) {
      console.error('[fetchVendorCategories] API call failed:', {
        message: error?.message,
        response: error?.response?.data,
        status: error?.response?.status
      });
      return rejectWithValue(error?.message || "Please try again later!");
    }
  }
);

export const fetchSoftwareCategories = createAsyncThunk<GenericObjectInterface>(
  "ungated/softwarecategories",
  async (_, { rejectWithValue, getState }) => {
    const state: any = getState();

    const { unGatedContentStateReducer } = state;
    console.log('[fetchSoftwareCategories] Starting API call to:', API_ENDPOINTS.ALL_CATEGORIES);

    try {
      const headerList = {
        ...headersList,
        // Authorization: `Token ${userStateReducer?.userToken}`,
      };
      const response = await makeApiRequest<GenericObjectInterface>(
        "get",
        API_ENDPOINTS.ALL_CATEGORIES,
        null,
        headerList
      );

      console.log('[fetchSoftwareCategories] API call successful:', response?.data);

      return response;
    } catch (error: any) {
      console.error('[fetchSoftwareCategories] API call failed:', {
        message: error?.message,
        response: error?.response?.data,
        status: error?.response?.status
      });
      return rejectWithValue(error?.message || "Please try again later!");
    }
  }
);
export const fetchSoftwareDetails = createAsyncThunk<GenericObjectInterface>(
  "ungated/softwares",
  async (_, { rejectWithValue, getState }) => {
    const state: any = getState();

    const { userStateReducer } = state;
    try {
      const headerList = {
        ...headersList,
        // Authorization: `Token ${userStateReducer?.userToken}`,
      };
      const response = await makeApiRequest<GenericObjectInterface>(
        "get",
        `${API_ENDPOINTS.PRODUCTS}`,
        null,
        headerList
      );

      return response?.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue("Please try again later!");
    }
  }
);
export const fetchCompareSoftwares = createAsyncThunk<GenericObjectInterface>(
  "ungated/compare_softwares",
  async (_, { rejectWithValue, getState }) => {
    const state: any = getState();

    const { userStateReducer } = state;
    try {
      const headerList = {
        ...headersList,
        // Authorization: `Token ${userStateReducer?.userToken}`,
      };
      const response = await makeApiRequest<GenericObjectInterface>(
        "get",
        `${API_ENDPOINTS.COMPARE_PRODUCTS}/`,
        null,
        headerList
      );

      return response?.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue("Please try again later!");
    }
  }
);
// export const fetchComparisonFeatures = createAsyncThunk<GenericObjectInterface>(
//   "ungated/comparison_features",
//   async (_, { rejectWithValue }) => {

//     try {
//       const headerList = {
//         ...headersList,
//       };
//       const response = await makeApiRequest<GenericObjectInterface>(
//         "get",
//         `${API_ENDPOINTS.COMPARE_FEATURES}/`,
//         null,
//         headerList
//       );

//       return response?.data;
//     } catch (error) {
//       console.error(error);
//       return rejectWithValue("Please try again later!");
//     }
//   }
// );
export const fetchProductComparison = createAsyncThunk<GenericObjectInterface, { productIds: string[] }>(
  "ungated/product_comparison",
  async ({ productIds }, { rejectWithValue }) => {

    try {
      const headerList = {
        ...headersList,
      };
      const response = await makeApiRequest<GenericObjectInterface>(
        "get",
        `${API_ENDPOINTS.PRODUCT_COMPARISON}?productIds=${productIds?.join(",")}&populate=*`,
        null,
        headerList
      );

      return response?.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue("Please try again later!");
    }
  }
);
export const fetchBlogsDetails = createAsyncThunk<GenericObjectInterface>(
  "ungated/blogs",
  async (_, { rejectWithValue, getState }) => {
    const state: any = getState();

    const { userStateReducer } = state;
    try {
      const headerList = {
        ...headersList,
        // Authorization: `Token ${userStateReducer?.userToken}`,
      };
      const response = await makeApiRequest<GenericObjectInterface>(
        "get",
        API_ENDPOINTS.BLOGS,
        null,
        headerList
      );

      return response?.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue("Please try again later!");
    }
  }
);

export const fetchSearchProducts = createAsyncThunk<GenericObjectInterface[]>(
  "ungated/search_products",
  async (_, { rejectWithValue, getState }) => {
    const state: any = getState();

    const { userStateReducer } = state;
    try {
      const headerList = {
        ...headersList,
        // Authorization: `Token ${userStateReducer?.userToken}`,
      };
      const response = await makeApiRequest<GenericObjectInterface[]>(
        "get",
        API_ENDPOINTS.SEARCH_PRODUCTS,
        null,
        headerList
      );

      return response?.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue("Please try again later!");
    }
  }
);




